import { render, staticRenderFns } from "./IdentifierDisplay.vue?vue&type=template&id=e2c46d5e&"
import script from "./IdentifierDisplay.vue?vue&type=script&lang=js&"
export * from "./IdentifierDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports